import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFLookupWarehouse } from "src/components/Shared/NewForms/NFLookupWarehouse";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

export const AssemblyDisassemblyOfGoodsDetailMain = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Document#")} fieldName={"documentNumber"} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany fieldName={"companyId"} required title={t("Company")} />
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
          <NFLookupWarehouse fieldName={"warehouseId"}  title={t("Warehouse")} companyId={watch('companyId')}/>
        </Col>
        <Col sm={6}>
          <NFLookupDivision fieldName={"divisionId"} title={t("Division")} companyId={watch('companyId')}/>
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupProduct fieldName={"productId"} title={t("Product")} />
        </Col>
        <Col sm={4}>
          <NFLookupUnit title={t("Unit")} fieldName={"unitId"} />
        </Col>
        <Col sm={2}>
          <NFTextInput fieldName={"quantity"} title={t("Quantity")} />
        </Col>
      </Row>
    </>
  );
};
